export const InputMode = {
  EMAIL: "email",
  TEXT: "text",
  TEL: "tel",
  NUMERIC: "numeric",
  NONE: "none",
  URL: "url",
  DECIMAIL: "decimal",
  SEARCH: "search"
}
export type InputMode = typeof InputMode[keyof typeof InputMode];